import { render, staticRenderFns } from "./delivery-selector.vue?vue&type=template&id=00f23557&"
import script from "./delivery-selector.vue?vue&type=script&lang=js&"
export * from "./delivery-selector.vue?vue&type=script&lang=js&"
import style0 from "./delivery-selector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00f23557')) {
      api.createRecord('00f23557', component.options)
    } else {
      api.reload('00f23557', component.options)
    }
    module.hot.accept("./delivery-selector.vue?vue&type=template&id=00f23557&", function () {
      api.rerender('00f23557', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/checkout/delivery-selector/delivery-selector.vue"
export default component.exports